import { GetStatusModel } from "@factory/model/query-model-status";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { statusFormDefault } from "./form.default";
import { StatusFormSchema } from "./form.rule";

export const useFormDefaultStatus = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetStatusModel | undefined) => {
    return !cachedValue
      ? statusFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as StatusFormSchema);
  };

  return {
    getDefault,
  };
};
